import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PriceContext } from '../Context/PriceContext';
import { FaGem, FaCrown, FaBolt } from 'react-icons/fa';
import { GiCutDiamond, GiCrystal } from 'react-icons/gi';
import { IoMdStar } from 'react-icons/io';
import './PricePredictor.css';
import Mount from '../Mount';
import { Helmet } from 'react-helmet';

const PricePredictor = () => {
  const { paymentData = {} } = useContext(PriceContext);
  const navigate = useNavigate();
  const [currentOfferIndex, setCurrentOfferIndex] = useState(0);
  const [particles, setParticles] = useState([]);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const OFFERS = [
    {
      title: "DIAMOND BADGE",
      description: "Unlock Full Dashboard Access",
      price: "$33",
      duration: "year",
      Icon: GiCutDiamond,
      iconColor: "#A250A0",
      features: [
        "Free 3D Content",
        "Technical Demos",
        "Searchable Library",
         "Priority Support 24/7"
        
      ],
      link: "",
      progress: 100
    },
    {
      title: "SUPPORTER PASS",
      description: "Upgrade anytime to unlock the full experience.",
      price: "$5",
      duration: "month",
      Icon: FaCrown,
      iconColor: "#FA60A8",
      features: [
        "Basic Access",
        "Mystery Packs",
        "Flash Content",
        "Flexible Upgrade"
      ],
      link: "",
      progress: 100
    },
    {
      title: "FLASH OFFER",
      description: "Supporter Pass Required",
      price: "FREE",
      duration: "",
      Icon: FaBolt,
      iconColor: "#FFD700",
      features: [
        "Early Access",
        "Voting Rights",
        "Technical Guides",
        "Discord"
      ],
      link: "",
      progress: 73
    }
  ];

  // Generate particles
  useEffect(() => {
    const newParticles = [];
    for (let i = 0; i < 50; i++) {
      newParticles.push({
        id: i,
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 10}s`,
        size: `${Math.random() * 6 + 2}px`,
        duration: `${Math.random() * 15 + 10}s`
      });
    }
    setParticles(newParticles);
  }, []);

  const handleOfferClick = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentOfferIndex((prev) => (prev + 1) % OFFERS.length);
      setIsTransitioning(false);
    }, 300);
  };

  const currentOffer = OFFERS[currentOfferIndex];
  const IconComponent = currentOffer.Icon;

  const handlePreview = (e) => {
    e.preventDefault();
    navigate('/creator-dashboard?preview=true', {
      state: { preview: true, fromPricePredictor: true }
    });
  };

  return (
    <div className="price-predictor">
      {/* Background orbs */}
      <div className="orb orb-1"></div>
      <div className="orb orb-2"></div>

      {/* Particles */}
      {particles.map((p) => (
        <div
          key={p.id}
          className="particle"
          style={{
            left: p.left,
            width: p.size,
            height: p.size,
            animationDelay: p.animationDelay,
            animationDuration: p.duration,
            background: currentOffer.iconColor
          }}
        />
      ))}

      <Helmet>
        <title>Restricted Access | Contranorm Media & Production™</title>
      </Helmet>

      <>
        <div className="sport">
          <div className="pricing-title">
            <h1>Access Credentials</h1>
            <p>Swap & Test New Content</p>
          </div>

          <form onSubmit={handlePreview}>
            <div className="price-options">
              <div className="badge-container">
                <div className="offer-card"
                  style={{
                    opacity: isTransitioning ? 0 : 1,
                    transform: isTransitioning ? 'scale(0.95)' : 'scale(1)',
                  }}
                >
                  <div className="icon-container">
                    <div
                      className="icon-flow"
                      onClick={handleOfferClick}
                      title="Click to switch offer"
                    >
                      <IconComponent style={{ color: currentOffer.iconColor }} />
                    </div>
                  </div>

                  <h2 className="offer-title">{currentOffer.title}</h2>

                  <div className="offer-description">{currentOffer.description}</div>

                  <div className="price-display">
                    <span className="price">{currentOffer.price}</span>
                    <span className="duration"> {currentOffer.duration}</span>
                  </div>

                  {currentOffer.progress < 100 && (
                    <div className="progress-bar">
                      <div className="progress-fill" style={{ width: `${currentOffer.progress}%` }} />
                    </div>
                  )}

                  <ul className="feature-list">
                    {currentOffer.features.map((feature, i) => (
                      <li key={i}>
                        <IoMdStar />
                        {feature}
                      </li>
                    ))}
                  </ul>

                  
                </div>
              </div>
            </div>

            <div className="predictor-submit-container">
              <button type="submit" className="submit">
        
                PREVIEW
              </button>
              <button
                type="button"
                className="submit gray"
                onClick={() => {
                  window.location.href = 'https://mods.contranormdigital.com/passes/supporter-pass-with-diamond-badge-combo/';
                }}
              >
                PLEDGE
              </button>
            </div>
          </form>
          
        </div>
        
      </>
      
    </div>
  );
};

export default PricePredictor;